<nb-card id="contract" style="display: none;">
  <nb-card-header id="contracttext" class="pb-2">
    合約提醒：
    <br>
  </nb-card-header>
  
</nb-card>

<nb-card>
    <nb-card-header class="pb-2">
        公告        
    </nb-card-header>
</nb-card>


  
<nb-accordion class="w-100"  multi>
  <nb-accordion-item *ngFor="let item of dataList"  expanded="false">
    <nb-accordion-item-header>
      <div class="d-flex justify-content-between col-sm-12">          
        <div>{{ item.Title}}</div>
        <div>{{ item.StartDateTime }}</div>   
      </div>
      
    </nb-accordion-item-header>
    <nb-accordion-item-body>

      <pre class="pre w-100 px-3 mb-0">
        {{item.Content}}
      </pre>        

    </nb-accordion-item-body>
  </nb-accordion-item>                        
</nb-accordion>


<ng2-smart-table-pager  class="onlyPageNav" [source]="Source" (changePage)="onPage($event)">  
</ng2-smart-table-pager>
